import proj4 from "proj4";
import { RoutesProvider as RoutesProviderV2 } from "./utils/framer_v2/routesprovider";
import { LidarProvider } from "./utils/lidarprovider";
import { GeohashGeometryProvider } from "./GeohashGeometryProvider";
import { Spatial } from "../geo/Spatial";
import { DataProviderBase } from "./DataProviderBase";
import { Infra3DSDKError } from "../error/Infra3DSDKError";
import { Subject } from "rxjs";
import { publishReplay, refCount, startWith } from "rxjs/operators";
// TODO: Sort and structure all import of mapillary code.
// TODO: Option guards.
// TODO: Once in infra3dsdk, really think about frame props, capturesystem and framedatameta.
// Geoframe vs MeasureInfo.
// TODO: Remove more that is not needed.
// TODO: Typesafer IO
// TODO: Options of viewer need to be asserted at one place.
export class UtilsBase {
    static cornersProjectedTo({ ne, nw, se, sw }) {
        return {
            ne: UtilsBase.projectedTo(ne),
            nw: UtilsBase.projectedTo(nw),
            se: UtilsBase.projectedTo(se),
            sw: UtilsBase.projectedTo(sw),
        };
    }
    static projectedTo({ lon: x, lat: y }, epsg = 4326) {
        const { x: lon, y: lat } = proj4("EPSG:4326", `EPSG:${epsg}`, {
            x,
            y,
        });
        return { lon, lat };
    }
    static projectedFrom({ lon: x, lat: y }, epsg = 4326) {
        const { x: lon, y: lat } = proj4(`EPSG:${epsg}`, "EPSG:4326", {
            x,
            y,
        });
        return { lon, lat };
    }
    static coreImages(frames) {
        console.error("Not implemented!");
        const res = {};
        return res;
    }
    static fillImages(frames) {
        console.error("Not implemented!");
        const res = {};
        return res;
    }
    static fullImages(frames) {
        console.error("Not implemented!");
        const res = {};
        return res;
    }
    static sequences(frames) {
        return frames.map((frame) => frame.key);
    }
}
export class ICoreNodeWrapperBase {
    constructor(frame) {
        this.frame = frame;
    }
    get key() {
        return this.frame.key;
    }
    get cl() {
        return {
            lon: this.frame.longitude,
            lat: this.frame.latitude,
        };
    }
    get l() {
        return {
            lon: this.frame.longitude,
            lat: this.frame.latitude,
        };
    }
    get sequence_key() {
        console.error("Not implemented!");
        return "";
    }
}
export class IFillNodeWrapperBase {
    constructor(frame) {
        this.frame = frame;
    }
    get camera_projection_type() {
        return this.frame.streamtype;
    }
    get ca() {
        // TODO: This is most likely not need since now c_rotation is implemented.
        return Spatial.degToRad(this.frame.kappa);
    }
    get c_rotation() {
        return Spatial.rotationFromEulerAnglesDegAndVehicleOrientation(this.frame.omega, this.frame.phi, this.frame.kappa, this.frame.capturesystem.orientation);
    }
    get captured_with_camera_uuid() {
        console.error("Not implemented!");
        return "";
    }
    get captured_at() {
        return new Date(this.frame.timestamp).getTime();
    }
    get height() {
        return this.frame.framedatameta.imageheight;
    }
    get width() {
        return this.frame.framedatameta.imagewidth;
    }
    get private() {
        return false;
    }
    get user() {
        return { key: "iNovitas", username: "iNovitas" };
    }
    get merge_version() {
        return 9999;
    }
    get calt() {
        return this.frame.height;
    }
    get project() {
        return {
            key: this.frame.campaignID,
        };
    }
}
export class IFullNodeWrapperBase {
    get frame() {
        return this.iFillNodeWrapper.frame;
    }
    get key() {
        return this.iCoreNodeWrapper.key;
    }
    get cl() {
        return this.iCoreNodeWrapper.cl;
    }
    get l() {
        return this.iCoreNodeWrapper.l;
    }
    get sequence_key() {
        return this.iCoreNodeWrapper.sequence_key;
    }
    get camera_projection_type() {
        return this.iFillNodeWrapper.camera_projection_type;
    }
    get ca() {
        return this.iFillNodeWrapper.ca;
    }
    get c_rotation() {
        return this.iFillNodeWrapper.c_rotation;
    }
    get captured_at() {
        return this.iFillNodeWrapper.captured_at;
    }
    get height() {
        return this.iFillNodeWrapper.height;
    }
    get width() {
        return this.iFillNodeWrapper.width;
    }
    get captured_with_camera_uuid() {
        return this.iFillNodeWrapper.captured_with_camera_uuid;
    }
    get private() {
        return this.iFillNodeWrapper.private;
    }
    get user() {
        return this.iFillNodeWrapper.user;
    }
    get merge_version() {
        return this.iFillNodeWrapper.merge_version;
    }
    get project() {
        return this.iFillNodeWrapper.project;
    }
}
export class Infra3DDataProviderBase extends DataProviderBase {
    constructor(options, authObject, projectScope, lidarprovideroptions, geometry) {
        super(geometry ? geometry : new GeohashGeometryProvider(options.collection));
        this.lidarProvider = null;
        this.collection = options.collection;
        this._collectionSubject$ = new Subject();
        this._collection$ = this._collectionSubject$.pipe(startWith(this.collection), publishReplay(1), refCount());
        if (lidarprovideroptions) {
            this.lidarProvider = new LidarProvider(lidarprovideroptions.host, authObject, projectScope);
        }
    }
    get collection$() {
        return this._collection$;
    }
    getCollection() {
        return this.collection;
    }
    setCollection(collection) {
        this.frameProvider.clearCache();
        if (this._geometry instanceof GeohashGeometryProvider)
            this._geometry.setCollection(collection);
        this.collection = collection;
        this._collectionSubject$.next(collection);
    }
    getCoreImages(cellId) {
        return Promise.reject(new Infra3DSDKError("Not implemented"));
    }
    getFillImages(imageKeys) {
        return Promise.reject(new Infra3DSDKError("Not implemented"));
    }
    getFullImages(imageKeys) {
        return Promise.reject(new Infra3DSDKError("Not implemented"));
    }
    getSequences(sequenceKeys) {
        const [sequenceKey] = sequenceKeys;
        return new Promise((resolve, reject) => {
            function handleSuccess(frames) {
                resolve({
                    [sequenceKey]: {
                        key: sequenceKey,
                        keys: UtilsBase.sequences(frames),
                    },
                });
            }
            function handleError(error) {
                reject(error);
            }
            this.frameProvider.allSequence(this.collection, sequenceKey, handleSuccess, handleError);
        });
    }
    getFramesAsGeoJSON(extent, epsg, skip, limit = 100, overlap = 10) {
        return new Promise((resolve, reject) => {
            this.frameProvider.allWithinAsGeoJSON(this.collection, extent[0] - overlap, extent[2] + overlap, extent[1] - overlap, extent[3] + overlap, epsg, skip, limit, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getRoutes(options) {
        return Promise.reject(new Infra3DSDKError("Not implemented"));
    }
    getRoutesOutline() {
        return new Promise((resolve, reject) => {
            if (this.routesProvider instanceof RoutesProviderV2) {
                this.routesProvider.allRoutesOutline(this.collection, (geojson) => {
                    resolve(geojson);
                }, (error) => {
                    reject(error);
                });
            }
            else {
                reject(new Infra3DSDKError("Only implemented for framer v2"));
            }
        });
    }
    findNearest(easting, northing, epsg) {
        return Promise.reject(new Infra3DSDKError("Not implemented"));
    }
    orderLidarFragments(email, user_uid, fragments_uids) {
        return new Promise((resolve, reject) => {
            this.lidarProvider.orderLidarFragments(this.collection, email, user_uid, fragments_uids, (resp) => {
                resolve(resp);
            }, (error) => {
                reject(error);
            });
        });
    }
    set authObject(authObject) {
        this.frameProvider.authObject = authObject;
        this.routesProvider.authObject = authObject;
    }
}
proj4.defs([
    [
        "EPSG:21781",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000" +
            " +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs",
    ],
    [
        "EPSG:2056",
        "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +x_0=2600000+y_0=1200000 +ellps=bessel" +
            " +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
    ],
    [
        "EPSG:31466",
        "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
    ],
    [
        "EPSG:31467",
        "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
    ],
    [
        "EPSG:31468",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
    ],
    [
        "EPSG:31469",
        "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
    ],
    ["EPSG:25830", "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs"],
    ["EPSG:25831", "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs"],
    ["EPSG:25832", "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs"],
    ["EPSG:25833", "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs"],
    [
        "EPSG:31258",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=450000 +y_0=-5000000 +ellps=bessel" +
            " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    ],
    [
        "EPSG:31255",
        "+proj=tmerc +lat_0=0 +lon_0=13.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel" +
            " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    ],
    [
        "EPSG:31700",
        "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass" +
            " +towgs84=28,-121,-77,0,0,0,0 +units=m +no_defs",
    ],
    [
        "EPSG:3765",
        "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0" +
            " +units=m +no_defs",
    ],
    [
        "EPSG:31256",
        "+proj=tmerc +lat_0=0 +lon_0=16.33333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel" +
            " +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    ],
    [
        "EPSG:31287",
        "+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000" +
            " +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    ],
    ["EPSG:25832", "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs"],
    ["EPSG:3006", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"],
    [
        "EPSG:3007",
        "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m" +
            " +no_defs",
    ],
    [
        "EPSG:3008",
        "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m" +
            " +no_defs",
    ],
    ["EPSG:32636", "+proj=utm +zone=36 +ellps=WGS84 +datum=WGS84 +units=m +no_defs "],
    [
        "EPSG:3857",
        "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs",
    ],
]);
//# sourceMappingURL=Infra3DDataProviderBase.js.map